module.exports = __webpack_public_path__ + "static/img/no.95b374a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/no.jpg
// module id = URi8
// module chunks = 1